import { get } from 'object-path';
import { OrderItemPrintShadeTypes } from '..';

export function getPrintShade(item: any): OrderItemPrintShadeTypes {
  const color = get(item.printMeta, 'theme.primaryColor', '').toLowerCase();

  return item.colorMap[color]?.printShade || '';
}
